/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function PackageAcceptTemplatesEditViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $route: JS5Object,
    $routeParams: JS5Object,
    $timeout: JS5Function,
    BreadcrumbService: JS5Object,
    ModalService: JS5Object,
    PackageAcceptTemplatesService: JS5Object,
    PermissionsService: JS5Object,
    SidebarService: JS5Object,
) {
    this.editData = {};
    this.mediaAcceptProfileTypes = [
        'VIDEO',
        'AUDIO',
        'DOCUMENT',
        'IMAGE',
        'OTHER'
    ];
    const getData = () => {
        this.loadingIndicator.show = true;
        PackageAcceptTemplatesService.getPackageAcceptTemplate($routeParams.id).then((packageAcceptTemplate: JS5Object) => {
            PackageAcceptTemplatesService.originalEditData = _.cloneDeep(packageAcceptTemplate);
            this.editData = packageAcceptTemplate;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if ($routeParams.id === '-1') {
            saveNewPackageAcceptTemplate();
        }
        else {
            updatePackageAcceptTemplate();
        }
    };

    const updatePackageAcceptTemplate = () => {
        PackageAcceptTemplatesService.updatePackageAcceptTemplate(this.editData).then((packageAcceptTemplate: JS5Object) => {
            PackageAcceptTemplatesService.originalEditData = _.cloneDeep(packageAcceptTemplate);
            this.editData = packageAcceptTemplate;
            this.editorForm.$setPristine();
            getData();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };
    const saveNewPackageAcceptTemplate = () => {
        PackageAcceptTemplatesService.createPackageAcceptTemplate(this.editData).then((packageAcceptTemplate: JS5Object) => {
            $route.updateParams({id: packageAcceptTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine') &&
                _.size(_.get(this.editData, 'name')) &&
                _.size(_.filter(_.get(this.editData, 'mediaAcceptProfiles'), {type: 'VIDEO'})),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(PackageAcceptTemplatesService.originalEditData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/templates/search`).search({
                tab: 'Media',
                subTab: 'PackageAcceptTemplates'
            })
        }
    ];


    this.$onInit = () => {
        SidebarService.editService = PackageAcceptTemplatesService;
        this.isAdmin = PermissionsService.isAdmin();
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if (this.isAdmin) {
            if ($routeParams.id !== '-1') {
                if (!_.size(BreadcrumbService.getBreadcrumbs())) {
                    BreadcrumbService.addBreadcrumb({
                        name: 'Edit Package Accept Template',
                        location: '/system/templates/search',
                        params: {tab: 'Media', subTab: 'PackageAcceptTemplates'}
                    });
                }
                getData();
            } else {
                _.set(this.editData, 'mediaAcceptProfiles', []);
                PackageAcceptTemplatesService.originalEditData = _.cloneDeep(this.editData);
                BreadcrumbService.addBreadcrumb({
                    name: 'Create Package Accept Template',
                    location: '/system/templates/search',
                    params: {tab: 'Media', subTab: 'PackageAcceptTemplates'}
                });
            }
        } else {
            $location.url('/login');
        }
    };

    this.$onDestroy = () => {
        PackageAcceptTemplatesService.originalEditData = null;
        PackageAcceptTemplatesService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            PackageAcceptTemplatesService.editorForm = this.editorForm;
            BreadcrumbService.editService = PackageAcceptTemplatesService;
        });
    };
}


angular.module('prism-ui.packageAcceptTemplate').component('packageAcceptTemplatesEditView', {
    templateUrl: 'system/templates/packageAcceptTemplates/editView/package-accept-templates-edit-view-template.html',
    controller: PackageAcceptTemplatesEditViewController,
    bindings: {
    }
});
